import React from 'react';
import Async from 'react-select/async';
import moment from 'moment-timezone';
import { timezoneStore } from '../TimezoneStore';
import MultiDropdownGroupedAsync from 'ats/components/multi-dropdown-grouped/MultiDropdownGroupedAsync';
import { reactSelectAtsComponents } from 'ats/components/react-select/reactSelectAtsComponents';

export class TimezoneDropdown extends React.Component {
	state = {
		value: null,
		loaded: false
	};
	async componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
			this.setState({ loaded: true });
			return;
		}
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			const { placeholder = 'Select an option', isMulti } = this.props;
			// Multi-select uses the grouped async wrapper so currently selected
			// timezones are pinned at the top and the count pill is rendered.
			const Component = isMulti ? MultiDropdownGroupedAsync : Async;

			return (
				<Component
					menuPosition={this.props.menuPosition || 'fixed'}
					menuPlacement={this.props.menuPlacement || 'auto'}
					closeMenuOnScroll={this.props.closeMenuOnScroll}
					menuPortalTarget={this.props.menuPortalTarget}
					styles={this.props.styles}
					usePurpleStyles={
						this.props.styleVersion === 'ats' || this.props.usePurpleStyles
					}
					maxMenuHeight="300"
					classNamePrefix={
						this.props.classNamePrefix ||
						'react-select' +
							(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
					}
					isMulti={isMulti}
					isClearable={this.props.isClearable}
					components={
						!isMulti && this.props.styleVersion === 'ats'
							? reactSelectAtsComponents
							: undefined
					}
					className={
						'react-select ' +
						(isMulti ? 'ats-multi-dropdown ats-multi-dropdown-grouped ' : '') +
						(this.props.styleVersion ? this.props.styleVersion : '') +
						(this.props.isInvalid ? ' has-error' : '')
					}
					value={
						this.props.value === undefined ? this.state.value : this.props.value
					}
					placeholder={placeholder}
					defaultOptions
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getTimeZones(inputValue));
		});
	};

	getTimeZones = async inputValue => {
		inputValue = inputValue.trim();
		const result = await timezoneStore.getTimezones(inputValue);
		const timezones = result.data;
		return timezones;
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search job roles';
		}
	};

	getViewerTimezone = async () => {
		const result = await timezoneStore.getTimezones('');
		const timezones = result.data;
		const now = moment.utc();
		const viewerTimeZoneutcOffset = moment.tz
			.zone(moment.tz.guess())
			.utcOffset(now);
		const differenceInHours = (viewerTimeZoneutcOffset / 60) * -1;
		const viewerTimezone = timezones.find(
			item => parseFloat(item.offset) === parseFloat(differenceInHours)
		);
		return viewerTimezone;
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.text}`;
}
